import(/* webpackMode: "eager" */ "/workspace-install/projects/astrolive-app/modules/Astro/FreeReports/Partner/index.tsx")